import React, { FC } from 'react';
import type { Destination } from 'src/common/types/api/v4/boats/search';
import type { PageDataFromBreadCrumbs } from 'src/search/utils/getPageDataFromBreadcrumbs';
import Typography from 'src/common/components/Typography';
import { PATHS } from 'src/common/constants';
import TopDestination from 'src/common/components/TopDestination';
import { DEFAULT_SLUG } from 'src/search/constants';

import DlpLayout from 'src/search/components/DlpLayout';
import styles from './dlpTopLocations.module.scss';

export type DlpTopDestinationProps = {
  destinations: Destination[];
  title: string;
} & Pick<PageDataFromBreadCrumbs, 'primarySlug'>;

const DlpTopDestinations: FC<DlpTopDestinationProps> = ({
  destinations,
  title,
  primarySlug,
}) => (
  <DlpLayout>
    <div
      className={styles.root}
    >
      <Typography
        type="h3"
        size="heading-4"
        weight="semibold"
      >
        {title}
      </Typography>
      <ul className={styles.grid}>
        {destinations.map((destination) => {
          const categorySegment = primarySlug === DEFAULT_SLUG ? '' : `${primarySlug}/`;
          const href = `${PATHS.SEARCH}${categorySegment}${destination.slug}/`;
          return (
            <TopDestination
              key={destination.slug}
              href={href}
              destination={destination}
            />
          );
        })}
      </ul>
    </div>
  </DlpLayout>
);

export default DlpTopDestinations;
